import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import PageLayout from "../../components/PageLayout/PageLayout";
import UserList from "./UserList/UserList";

import { AppDispatch } from "../../app/store";

import {
  getAdminUsers,
  selectAdminUsers,
  selectAdminUsersLoading,
  selectAdminUsersError,
} from "../../slices/adminUser/adminUserSlice";

import styles from "./AdminUsers.module.css";

const AdminUsers: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const users = useSelector(selectAdminUsers);
  const loading = useSelector(selectAdminUsersLoading);
  const error = useSelector(selectAdminUsersError);

  useEffect(() => {
    dispatch(getAdminUsers());
  }, [dispatch]);

  return (
    <PageLayout className={styles.AdminUsers}>
      <h1 className={styles.Title}>
        Użytkownicy
      </h1>

      <div className={styles.InfoBox}>
        <div className={styles.InfoTitle}>
          Zarządzanie użytkownikami
        </div>

        <div className={styles.InfoText}>
          Przeglądaj użytkowników, ich należności
          oraz aktywność w serwisie.
        </div>
      </div>

      {loading && (
        <div className={styles.Message}>
          Pobieranie użytkowników...
        </div>
      )}

      {!loading && error && (
        <div className={styles.Error}>
          {error}
        </div>
      )}

      {!loading && !error && (
        <UserList users={users} />
      )}
    </PageLayout>
  );
};

export default AdminUsers;